import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { loginApi, LoginType } from '@/api/v1/users/public/loginApi';

export const login = async (payload: LoginType) => {
  try {
    const response = await loginApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
